import { useState } from "react";
import { ADDRESS_FIELD_MAX_LENGTH, EMPTY_ADDRESS } from "./ticketFormConfig";
import { getFieldInputError, getMissingAddressFields } from "./ticketFormHelpers";

// State and handlers of the "עדכון כתובת האתר" dialog.
// onSaved runs once a valid address is saved, so the form can uncheck "address confirmed".
export const useAddressChangeRequest = (onSaved) => {
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [addressChangeRequest, setAddressChangeRequest] = useState(EMPTY_ADDRESS);
  const [addressFieldErrors, setAddressFieldErrors] = useState(EMPTY_ADDRESS);

  const handleAddressFieldChange = (field, label, isNumeric) => (event) => {
    const value = event.target.value;
    const error = getFieldInputError(value, label, ADDRESS_FIELD_MAX_LENGTH, isNumeric ? "digits" : "letters");
    if (error) {
      setAddressFieldErrors((prev) => ({ ...prev, [field]: error }));
      return;
    }
    setAddressChangeRequest((prev) => ({ ...prev, [field]: value }));
    setAddressFieldErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleAddressDialogCancel = () => {
    setAddressDialogOpen(false);
    setAddressChangeRequest(EMPTY_ADDRESS);
    setAddressFieldErrors(EMPTY_ADDRESS);
  };

  const handleAddressDialogSave = () => {
    const missingRequiredErrors = getMissingAddressFields(addressChangeRequest);
    if (Object.keys(missingRequiredErrors).length > 0) {
      setAddressFieldErrors((prev) => ({ ...prev, ...missingRequiredErrors }));
      return;
    }

    setAddressDialogOpen(false);
    onSaved();
  };

  return {
    addressDialogOpen,
    setAddressDialogOpen,
    addressChangeRequest,
    addressFieldErrors,
    handleAddressFieldChange,
    handleAddressDialogCancel,
    handleAddressDialogSave,
  };
};
